// extracted by mini-css-extract-plugin
export default {"row":"ShareCourse_row__sFjx1","btn":"ShareCourse_btn__oYLU4","notice":"ShareCourse_notice__DEST8"};